import { scaffolderPlugin } from '@backstage/plugin-scaffolder'
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react'
import {
  SennderGitlabGroupPicker,
  validateSennderGitlabGroup
} from './SennderGitlabGroupPicker'

import { ComponentNameTextField, validateComponentName } from './ComponentNameTextField'
import { ComponentTypePicker, validateComponentType } from './ComponentTypePicker'

export const SennderGitlabGroupFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SennderGitlabGroupPicker',
    component: SennderGitlabGroupPicker,
    validation: validateSennderGitlabGroup
  })
)

export const ComponentNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ComponentNameTextField',
    component: ComponentNameTextField,
    validation: validateComponentName
  })
)

export const ComponentTypeFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ComponentTypePicker',
    component: ComponentTypePicker,
    validation: validateComponentType
  })
)
